import "./OAuthPage.scss";
import React, {useEffect, useState} from "react";
import {Button} from "antd";
import {useNavigate, useSearchParams} from "react-router-dom";
import {LogRegLogo} from "./util/LogRegLogo";
import DashboardApi from "../api/DashboardApi";
import {Spinner} from "./account/misc/Spinner";
import {env} from "../env/env";
import streamLogo from "../img/stream-logo.png";

const STREAM_REDIRECT_URL = 'https://dev.oauthgateway.com/redirect/mhm-dev/musthavemenus';

export default function StreamOAuthPage() {
  const navigate = useNavigate();
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setLoading(true);
    DashboardApi.status().then((resp) => {
      setLogged(resp.data.member?.logged ?? false);
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  function onLogin() {
    const params = new URLSearchParams(searchParams).toString();
    const next = `/account/stream/v1/authorize${encodeURIComponent(`?${params}`)}`;
    navigate(`/account/login?next=${next}`);
  }

  function onCancel() {
    navigate(env.dashboardPath);
  }

  function onAllow() {
    setLoading(true);
    DashboardApi.getStreamOAuthToken({grant_type: 'code'}).then(resp => {
      window.location.href = `${STREAM_REDIRECT_URL}?code=${resp.data.code}`;
    });
  }

  return (
    <div className={"oauth-page land-page"}>
      <div className="cvr"/>
      <div className={"step-login step"}>
        <LogRegLogo/>
        {loading && <Spinner/>}
        {!loading && <>
          <img style={{height: '50px', marginBottom: '36px'}} src={streamLogo} alt={'stream'}/>
          <h2>Stream requires access to read your designs</h2>

          <div className={"form"}>
            {!logged && <Button size={"large"} className={"primary"} onClick={onLogin}>Log In</Button>}
            {logged && <Button size={"large"} className={"primary"} onClick={onAllow}>Allow Stream to access my designs</Button>}
            {logged && <Button size={"large"} className={"primary-two"} onClick={onCancel}>Not now</Button>}
          </div>
        </>}
      </div>
    </div>
  );
}
